import store from "@/store";
import axios from "axios";

const getThaidToken = async () => {
    const token = store.getters["userAuth/getToken"];
    const keycloakUrl = process.env.VUE_APP_AUTH_KEYCLOAK_URL;
    const realm = process.env.VUE_APP_AUTH_KEYCLOAK_REALM;

    try {
        const response = await axios.get(
            `${keycloakUrl}/realms/${realm}/broker/thaid/token`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (err) {
        // ปกติถ้า user ไม่ได้ login ด้วย ThaID จะได้ 400/404
        return null;
    }
};

export default getThaidToken;
